import React from 'react';
import { clsx } from 'clsx';
import { CellComponentProps } from '../types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const MPAA_RATINGS = ["G", "PG", "PG-13", "R", "NC-17", "X"];

interface MPAARatingSelectProps extends CellComponentProps {
  disabled?: boolean;
  invalid?: boolean;
}

const MPAARatingSelect = React.forwardRef<any, MPAARatingSelectProps>(({
  value,
  onChange,
  isExpanded = false,
  disabled = false,
  invalid = false
}, ref) => {
  const currentValue = value as string;

  const handleValueChange = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <Select value={currentValue} onValueChange={handleValueChange} disabled={disabled}>
      <SelectTrigger className={clsx(
        "tw-w-full tw-h-auto tw-min-h-[2.5rem]",
        invalid && "!tw-border-red-500 focus-visible:!tw-ring-red-500"
      )}>
        <SelectValue placeholder="Select..." />
      </SelectTrigger>
      <SelectContent>
        {MPAA_RATINGS.map((rating) => (
          <SelectItem key={rating} value={rating}>
            {rating}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

export default MPAARatingSelect;